<template>
  <div class="page" id="search-create">
    <!--<div class="decorative-texture top">
      <img src="../../assets/img/texture.png" />
    </div>-->

    <section>
      <div class="container">
        <h1 class="section-title">Notas</h1>
        <div class="card head-card create-container">
          <div class="title-card">
            <h4>Agregar Busqueda</h4>
          </div>
          <div class="card-content">
            <div class="create-info">
              <h2 class="title info-title">Crear en</h2>
              <p class="subtitle greenBlue">{{ projectSelectedText }}</p>
              <p class="subtitle">Deseas guardas esta configuración para usar más tarde.</p>
              <div class="input-field">
                <!-- <label class="form-text">Título del video</label> -->
                <input type="text" placeholder="ej.Nombre del Proyecto" value v-model="nProyecto" />
              </div>
              <button class="button alternative" @click="saveNewProject()">Crear proyecto</button>
            </div>
            <projectlist-chose :newproject="newP"></projectlist-chose>
          </div>
        </div>
        <div class="page-actions">
          <button class="button width-25 alternative" @click="save()">Crear</button>
          <button class="button width-25 outline" @click="cancel()">Cancelar</button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import projectlistChose from "@/components/projectlistChose.vue";
import { bus } from "../../bus";
export default {
  name: "step4",
  components: {
    projectlistChose
  },
  data: () => ({
     url: this.$store.getters.getMainUrl,
    nProyecto: "",
    newP: null,
    projectSelected: "",
    projectSelectedText: "A continuación seleccione el proyecto"
  }),
  computed:{
    token(){
      return this.$store.getters.getToken;
    }
  },
  methods: {
    save() {
      if (this.projectSelected == "") {
        alert("Seleccione un proyecto");
      } else {
        this.saveGauge(this.projectSelected);
      }
    },
    /*cleanFiList(fi) {
      var list = {};
      Object.keys(fi).forEach(function(item) {
        if (fi[item].length > 0) {
          if (fi[item][0] == "all") {
            list[item] = [];
          } else {
            list[item] = fi[item];
          }
        }
      });

      return list;
    },*/
    cleanFiList(fi, param) {
      //naye
      var list = {};
      Object.keys(fi).forEach(function(item) {
        if (fi[item].length > 0) {
          list[item] = fi[item];
        } else {
          if (param[item][0] == 1 && param[item][1] == 1) {
            list[item] = [];
          }
        }
      });

      return list;
    },
    cancel() {
      this.$store.commit("clearProyectConfig");
      this.$router.push({
        path: "/"
      });
    },

    saveGauge(key) {
      var that = this;
      //var cleanList = this.cleanFiList(this.$store.state.projectConfig.fiList);
      var cleanList = this.cleanFiList(
        //naye
        this.$store.state.projectConfig.fiList,
        this.$store.state.projectConfig.fiParams
      ); //naye
      var cleanParam = this.cleanParams(
        this.$store.state.projectConfig.fiParams
      );
      var dat = JSON.stringify({
        dashboardKey: key,
        gaugeQuery: {
          fi: cleanList,
          fiParams: cleanParam,
          ubicacion: "global",
          fecha: this.$store.state.projectConfig.fecha,
          hora: this.$store.state.projectConfig.hora,
          keywords: this.$store.state.projectConfig.keywords
        },
        gaugeConfig: {
          gaugetype: this.tGrafica,
          gaugeName: this.nGauge
        },
        gaugeX: this.gaugeX,
        andQuery: this.$store.state.projectConfig.andQuery
      });
      console.log("createGauge...");
      console.log(dat);
      /*axios
        .post(
      
          dat
        )
        .then(function(response) {
          console.log(response);
          if (response.data.success == true) {
            that.$router.push({
              path: "/proyecto/" + key
            });
          }
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });*/
    },
    saveNewProject() {
      var that = this;
      var dat = JSON.stringify({
        token: this.token,
        providerID: this.$store.state.userInfo.net,
        data: {
          nombre: this.nProyecto,
          dashConfig: []
        }
      });
      axios
        .post(
          that.url + "createDashboard",
          dat
        )
        .then(function(response) {
          console.log(response);
          if (response.data.success == true) {
            that.newP = response.data.data;
            that.nProyecto = "";
          }
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    next() {
      // this.$router.push({path: '/proyecto/nuevo/step4'});
    },
    back() {
      this.$router.push({ path: "/proyecto/nuevo/step3" });
    },
    cleanParams(param) {
      var list = {};
      Object.keys(param).forEach(function(item) {
        if (param[item].length > 0) {
          list[item] = param[item];
        }
      });

      return list;
    }
  },
  watch: {},
  mounted() {
    var that = this;
    bus.$on("projectChose", data => {
      console.log(data);
      that.projectSelected = data.key;
      that.projectSelectedText = data.nombre;
    });
  },
  beforeMount() {
    console.log("BeforeStep4");
  }
};
</script>

<style lang="scss">
</style>
